module.exports = __webpack_public_path__ + "img/start1.98366562.png";